import React, { useEffect, useRef, useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Button,
  Box,
  Autocomplete,
  Chip,
  Grid,
} from "@mui/material";
import { Form, Field } from "react-final-form";
import { styled } from "@mui/material/styles";
import TextInput from "../../reusableComponents/components/generics/TextInput";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import {
  createFosaUser,
  fetchAdminId,
  updateFosaUser,
  validateUsername,
} from "../../action";
import { decodeId } from "../../utils/helper";
import { OnChange } from "react-final-form-listeners";
import debounce from "lodash/debounce";

const TableTitle = styled("div")({
  padding: 10,
  fontWeight: 600,
  color: "#333",
  backgroundColor: "#D3F0E0",
});





const AssignPermissionsDialog = ({
  open,
  onClose,
  initialValues,
  params,
  isPermission,
}) => {
  const { t } = useTranslation();

  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [username, setUsername] = useState("");

  const permissionsOptions = [
    { label: t("SubmitClaim"), value: 1 },
    { label: t("ManageStaff"), value: 2 },
    { label: t("verification"), value: 3 },
    // Add more options as needed
  ];

  const dispatch = useDispatch();




  useEffect(() => {
    if (initialValues?.user?.id)
      dispatch(fetchAdminId(decodeId(initialValues?.user?.id)));
  }, [initialValues?.user]);
  const fosaPermission = useSelector((state) => state?.fosaReducer);
  const getFosaId = useSelector((state) => state?.fosaReducer);

  const handleClickShowPassword = () => setShowPassword(!showPassword);
  const handleMouseDownPassword = () => setShowPassword(!showPassword);

  const handleClickShowConfirmPassword = () =>
    setShowConfirmPassword(!showConfirmPassword);
  const handleMouseDownConfirmPassword = () =>
    setShowConfirmPassword(!showConfirmPassword);
  console.log("initialValues", initialValues);
  const onSubmit = (values) => {
    if (initialValues?.user?.id) {
      dispatch(
        updateFosaUser({ values, userId: initialValues?.user?.id }, params)
      );
    } else {
      dispatch(createFosaUser(values, params));
    }
    onClose();
  };

  const policyholderIdMedical = localStorage.getItem("policyholderId");


  const validate = (values) => {
    const errors = {};
    if (values.confirmPassword !== values.password) {
      errors.confirmPassword = t('Passwords do not match');
    }
    if (!values.email) {
      errors.email = t("Field is required");
    } else if (
      !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(values.email)
    ) {
      errors.email = t("Invalid email address");
    }
    if (!values.userName) {
      errors.userName = t("Field is required");
    }
    if (!values.password) {
      errors.password = t("Field is required");
    }
    if (!values.confirmPassword) {
      errors.confirmPassword = t("Field is required");
    }
    if (!values.permissions || values.permissions.length === 0) {
      errors.permissions = t("Field is required");
    }
    return errors;
  };

  const required = (value) => (value ? undefined : "Required");
  const transformPermissions = (permissionsString) => {
    if (!permissionsString) return [];
    const permissionIds = permissionsString.split(",").map(Number);
    return permissionIds
      .map((id) => permissionsOptions.find((option) => option.value === id))
      .filter(Boolean);
  };
  const updateInitialVal = !!initialValues && {
    name: initialValues?.insuree?.lastName,
    insureeId: initialValues?.insuree?.id,
    fosaId: getFosaId?.pickerHealthFacilityInsurees?.[0]?.id,
    phId: policyholderIdMedical,
    userName: initialValues?.user?.id
      ? !!fosaPermission?.AdminIdData?.[0]?.username
        ? fosaPermission?.AdminIdData?.[0]?.username
        : ""
      : "",
    // email: initialValues?.user?.id
    // ? !!fosaPermission?.AdminIdData?.[0]?.email
    //   ? fosaPermission?.AdminIdData?.[0]?.email
    //   : ""
    // : "",
    permissions: initialValues?.user?.id
      ? !!fosaPermission?.AdminIdData?.[0]?.iUser?.fosaEmpPermissions
        ? transformPermissions(
          fosaPermission?.AdminIdData?.[0]?.iUser?.fosaEmpPermissions
        )
        : []
      : [],
  };

  const debouncedValidateUsername = useRef(
    debounce((username) => {
      dispatch(validateUsername(username));
    }, 1000)
  ).current;

  const handleUsernameChange = (event) => {
    console.log("checkusername", event);
    const username = event;
    setUsername(event);
    debouncedValidateUsername(username);
  };

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
      <DialogTitle>{t("Permissions")}</DialogTitle>
      <DialogContent>
        <Form
          onSubmit={onSubmit}
          validate={validate}
          initialValues={updateInitialVal}
          render={({ handleSubmit, form, submitting, pristine, values, errors }) => (
            <form onSubmit={handleSubmit} noValidate>
              <Grid container spacing={2}>
                <Grid item xs={12} sm={6}>
                  <Field
                    name="name"
                    component={TextInput}
                    label={t("Name")}
                    type="text"
                    disabled
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <Field
                    name="userName"
                    component={TextInput}
                    label={t("User Name")}
                    type="text"
                    required={true}
                    placeholder={t("Please Enter UserName")}
                    disabled={initialValues?.user?.id ? true : false}
                  />
                  {/* <OnChange name="userName">
                    {(value, previous) => {
                      console.log("value", value);
                      handleUsernameChange(value);
                    }}
                  </OnChange> */}
                </Grid>
                {!initialValues?.user?.id ? (
                  <>
                    <Grid item xs={12} sm={6}>
                      <Field
                        name="password"
                        component={TextInput}
                        label={t("password")}
                        required={true}
                        password={"password"}
                        error={errors.password}
                      />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <Field
                        name="confirmPassword"
                        component={TextInput}
                        error={errors.confirmPassword}
                        label={t("confirmPassword")}
                        // type={!!showConfirmPassword ? "text" : "password"}
                        required={true}
                        // showPassword={showConfirmPassword}
                        // handleMouseDownPassword={handleMouseDownConfirmPassword}
                        // handleClickShowPassword={handleClickShowConfirmPassword}
                        password={"password"}
                      />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <Field
                        name="email"
                        component={TextInput}
                        label="Email"
                        required={true}
                      />
                    </Grid>
                  </>
                ) : null}
                <Grid item xs={12}>
                  <Field name="permissions">
                    {({ input }) => (
                      <Autocomplete
                        multiple
                        options={permissionsOptions}
                        getOptionLabel={(option) => option.label}
                        getOptionSelected={(option, value) =>
                          option.value === value.value
                        }
                        value={input.value || []}
                        onChange={(event, newValue) => input.onChange(newValue)}
                        renderTags={(value, getTagProps) =>
                          value.map((option, index) => (
                            <Chip
                              key={option.value}
                              label={option.label}
                              {...getTagProps({ index })}
                            />
                          ))
                        }
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            placeholder={t("Select permissions")}
                            margin="dense"
                            fullWidth
                          />
                        )}
                      />
                    )}
                  </Field>
                </Grid>
              </Grid>
              <DialogActions>
                <Button onClick={onClose} variant="outlined">
                  {t("cancel")}
                </Button>
                <Button
                  type="submit"
                  color="primary"
                  variant="contained"
                  disabled={submitting || pristine || Object.keys(errors).length > 0}
                >
                  {t("save")}
                </Button>
              </DialogActions>
            </form>
          )}
        />
      </DialogContent>
    </Dialog>
  );
};

export default AssignPermissionsDialog;
